import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminHeader from '../../CommonComponents/AdminHeader'
import AdminFooter from '../../CommonComponents/AdminFooter'
import {
  getChildrenList,
  GetRoomAllocationDataById,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const RoomAllocationReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [reportData, setReportData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    const res = await axios.get(getChildrenList)
    setStudents(res.data)
  }

  const fetchReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(
        `${GetRoomAllocationDataById}/${selectedStudent}`
      )
      setReportData(res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">
              Room Allocation Report
            </h3>
          </div>

          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No: {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : Array.isArray(reportData) && reportData.length > 0 ? (
            <div className="a4-page">

              {/* HEADER */}
              <div className="text-center pb-3">
                <h2><b>सेंट क्रिस्पिन्स होम</b></h2>
                <h5><b>रूम वाटप अहवाल</b></h5>
              </div>

              {reportData.map((item, i) => (
                <div key={i} className="section">

                  {/* STUDENT NAME */}
                  <div className="row p-0 m-0">
                    <div className="col-12">
                      <p>
                        <b>विद्यार्थ्याचे नाव:</b>{' '}
                        {item.student?.full_name}
                      </p>
                    </div>
                  </div>

                  {/* DETAILS */}
                  <div className="row p-0 m-0">
                    <div className="col-12 col-md-6">
                      <p>
                        <b>वाटप दिनांक:</b> {item.allocation_date}
                      </p>
                    </div>

                    <div className="col-12 col-md-6">
                      <p>
                        <b>इमारत:</b> {item.building?.building_name}
                      </p>
                    </div>

                    <div className="col-12 col-md-6">
                      <p>
                        <b>विंग:</b> {item.wing?.wing_name}
                      </p>
                    </div>
                  </div>

                </div>
              ))}

            </div>
          ) : (
            <p style={{ padding: 20 }}>No Data Found</p>
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`
        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .section {
          margin-bottom: 20px;
        }

        .section p {
          color: black;
        }

        .text-center {
          text-align: center;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

          .section {
            page-break-inside: avoid;
          }

          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          .row > div {
            padding: 2px !important;
          }
        }
      `}</style>
    </>
  )
}

export default RoomAllocationReport